import React from "react";
import PropTypes from "prop-types";
import { easilGrayXDark } from "./style.module.css";

const TextAlignCenterIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 10"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-5h20v20H-2z" />
      <path
        fill={color || easilGrayXDark}
        d="M1 8h14a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm4-4h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2zM1 0h14a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z"
      />
    </g>
  </svg>
);
TextAlignCenterIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default TextAlignCenterIcon;
